import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDescIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 9V11H9V9H3ZM3 14V16H15V14H3ZM3 19V21H21V19H3Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21 7L17 3L13 7L14.4 8.4L16 6.8V11H18V6.8L19.6 8.4L21 7Z",
		fill: "currentColor"
	})]
});
export default SvgDescIcon;
